import React from 'react'
import {ServiceContainer, ServiceWrapper, ServiceContent, ServiceP,
ServiceImage, Image, ServiceHead} from "./ServiceElement" 
import img from "../../Images/s2.png"


const Service = () => {
    return (
        <ServiceContainer>
            <ServiceWrapper>
     
                <ServiceContent>
                    <ServiceP data-aos="fade-right"> 
                        <ServiceHead>We lay  good foundation for your<span style={{color:"#05386B"}}> Children</span></ServiceHead>
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit, quidem sapiente dicta 
                        fugiat veritatis molestiae fugit cumque alias aut magnam cum eveniet? Odit, 
                        iusto optio ipsa obcaecati tempora, ad dolores suscipit cum alias nisi maiores 
                        quibusdam dolore numquam reprehenderit. Unde
                    </ServiceP>

                    <ServiceImage data-aos="fade-left">
                         <Image src={img} alt="school"/>
                     </ServiceImage>
                </ServiceContent>

               
                

            </ServiceWrapper>
        </ServiceContainer>
    )
}

export default Service
